import { useState } from 'react';
export function useToggle(initialValue) {
    if (initialValue === void 0) { initialValue = false; }
    var _a = useState(initialValue), checked = _a[0], setChecked = _a[1];
    return {
        checked: checked,
        toggle: function () { return setChecked(function (prev) { return !prev; }); },
    };
}
